import { Component } from '@angular/core';
import { Layout } from 'app/views/presentations/layouts/layout';
import { LayoutComponent } from 'app/views/presentations/layouts/layout.component';

@Component({
    selector: `psm-three-sections-layout-4-component`,
    templateUrl: 'threeSectionsLayout4.component.html',
    styleUrls: ['../layout.component.scss']
})

export class ThreeSectionsLayout4Component extends LayoutComponent { }

export class ThreeSectionsLayout4 extends Layout {
    public type = 'ThreeSectionsLayout4';
    public componentType = ThreeSectionsLayout4Component;
    public numberOfSections = 3;
}


// WEBPACK FOOTER //
// ./src/app/views/presentations/layouts/layouts/threeSectionsLayout4/threeSectionsLayout4.component.ts